<!-- 上海-地产型绿色合格证彩色 -->
<template>
  <div class="card_common" ref="temCon" :style="containerStyle">
    <div class="card-con" :style="containerConStyle">
      <div class="scale-box" :style="style">
        <div class="land-normal-main_box">
          <div class="land-logo">
            <img src="./static/ls-bg1.png" alt="" />
            <div class="logo-txt">
              <p>{{ info.companyInformationCode }}</p>
              <p>经中国绿色食品发展中心许可使用绿色食品标志</p>
            </div>
          </div>
          <div class="land-normal-main_box_title">
            <div class="land-normal-main_box_title-top">
              <p>承诺达标合格证</p>
            </div>
            <div class="land-normal-main_box_title-bottom">
              <img
                src="./static/dcpthgz-text.png"
                @load="fileLoadFinish('bgImgDemo')"
              />
            </div>
          </div>
          <div class="land-normal-main_box_promise">
            <div class="land-normal-main_box_promise-top">
              <div class="land-normal-main_box_promise-top-item">
                <p class="land-normal-main_box_promise-top-item-title">
                  我承诺生产销售的食用农产品：
                </p>
                <ul>
                  <li>
                    <p class="land-normal-main_box_promise-top-item-term">
                      未使用禁用农药、兽药及其他化合物；
                    </p>
                  </li>
                  <li>
                    <p class="land-normal-main_box_promise-top-item-term">
                      使用的常规农药、兽药残留不超标。
                    </p>
                  </li>
                </ul>
              </div>
              <div class="land-normal-main_box_promise-top-item">
                <p class="land-normal-main_box_promise-top-item-title">
                  承诺依据
                </p>
                <ul>
                  <li>
                    <p
                      v-if="!getAttr('cnyj').includes(2)"
                      class="land-normal-main_box_promise-top-item-icon-normal"
                    ></p>
                    <p
                      v-else
                      class="land-normal-main_box_promise-top-item-icon"
                    ></p>
                    <p class="land-normal-main_box_promise-top-item-term">
                      质量安全控制符合要求
                    </p>
                  </li>
                  <li>
                    <p
                      v-if="!getAttr('cnyj').includes(1)"
                      class="land-normal-main_box_promise-top-item-icon-normal"
                    ></p>
                    <p
                      v-else
                      class="land-normal-main_box_promise-top-item-icon"
                    ></p>
                    <p class="land-normal-main_box_promise-top-item-term">
                      自行检测合格
                    </p>
                  </li>
                  <li>
                    <p
                      v-if="!getAttr('cnyj').includes(0)"
                      class="land-normal-main_box_promise-top-item-icon-normal"
                    ></p>
                    <p
                      v-else
                      class="land-normal-main_box_promise-top-item-icon"
                    ></p>
                    <p class="land-normal-main_box_promise-top-item-term">
                      委托检测合格
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <p class="land-normal-main_box_promise-code-title">
              承诺达标合格证
            </p>
            <div class="land-normal-main_box_promise-code">
              <div class="land-normal-main_box_promise-code-img">
                <img
                  :src="info.qrCodeUrl"
                  class="template-box_promise-code-img"
                  @load="fileLoadFinish('qrcodeDemo')"
                  alt=""
                />
                <img
                  v-show="!info.qrCodeUrl"
                  src="./static/app_code.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="land-normal-main_box_product">
            <ul>
              <li>
                <p class="land-normal-main_box_product-key">产品名称</p>
                <p class="land-normal-main_box_product-value">
                  {{ getAttr("spmc").substring(0, 12) }}
                </p>
              </li>
              <li>
                <p class="land-normal-main_box_product-key">重量或数量</p>
                <p class="land-normal-main_box_product-value">
                  {{ getAttr("zl") }}
                </p>
              </li>
              <li>
                <p class="land-normal-main_box_product-key">产地</p>
                <p class="land-normal-main_box_product-value">
                  {{ getAttr("cd") }}
                </p>
              </li>
              <li v-show="getAttr('qzys') !== '0'">
                <p
                  class="land-normal-main_box_product-key"
                  style="white-space: nowrap"
                >
                  承诺主体
                </p>
                <p class="land-normal-main_box_product-value">
                  {{ getAttr("qzmc") }}
                </p>
              </li>
              <li>
                <p class="land-normal-main_box_product-key">联系方式</p>
                <p class="land-normal-main_box_product-value">
                  {{ getAttr("kfdh") }}
                </p>
              </li>
              <li>
                <p class="land-normal-main_box_product-key">开具日期</p>
                <p class="land-normal-main_box_product-value">
                  {{ getAttr("kjrq").split(".").join("-") }}
                </p>
              </li>
            </ul>
            <div v-show="getAttr('qzys') === '1'" class="gongzhang_style">
              <img
                :src="info.sealImg"
                alt=""
                @load="fileLoadFinish('sealDemo')"
              />
            </div>
            <div v-show="getAttr('qzys') === '2'" class="sizhang_style">
              <img
                :src="info.sealImg"
                alt=""
                @load="fileLoadFinish('sealDemo')"
              />
            </div>
            <div v-show="getAttr('qzys') === '3'" class="gongzhang_style">
              <img
                :src="info.sealImg"
                alt=""
                @load="fileLoadFinish('sealDemo')"
              />
            </div>
            <div v-show="getAttr('qzys') === '4'" class="gongzhang_style">
              <img
                :src="info.sealImg"
                alt=""
                @load="fileLoadFinish('sealDemo')"
              />
            </div>
          </div>
          <div class="land-normal-main_box_footer">
            <p v-if="info.certificateNo">
              合格证编号：{{ info.certificateNo }}
            </p>
            <p v-else>合格证编号：编号自动生成</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hgz",
  data() {
    return {};
  },
  props: {
    info: {
      type: Object,
      default() {
        return {
          width: 0,
          height: 0,
          qrCodeUrl: "",
          rotate: false,
          attrRespList: [],
          certificateId: "",
          certificateNo: null,
          companyInformationCode: "",
          greenFood: true,
        };
      },
    },
  },
  computed: {
    containerStyle() {
      let width = 452;
      let height = 565;
      return {
        width: `${width * this.scale * 0.8}px`,
        height: `${height * this.scale * 0.8}px`,
      };
    },
    containerConStyle() {
      let options = this.isHorizontal
        ? {
            width: this.containerStyle.height,
            height: this.containerStyle.width,
          }
        : this.containerStyle;
      return options;
    },
    style() {
      let options = {
        transform: `scale(${this.scale * 0.8} , ${this.scale * 0.8})`,
        "transform-origin": "left top",
      };
      return options;
    },
    scale() {
      const { width, height } = this.info;
      if (!width && !height) {
        return 1;
      }
      if (width) {
        return width / 452;
      } else {
        return height / 565;
      }
    },
  },
  methods: {
    getAttr(key) {
      return this.info.attrRespList.filter((i) => i.attrKey === key)[0]
        ?.attrVal;
    },
    fileLoadFinish(type) {
      this.$emit("load", type);
    },
  },
};
</script>

<style lang="scss" scoped>
/* prettier-ignore */
$baseFont: 1PX;
$color: #009a53;
$bgcolor: #f0f9f5;
@media print {
  * {
    margin: 0;
    padding: 0;
  }
}
.card_common {
  display: flex;
  justify-content: center;
  align-items: center;
  .card-con {
    .scale-box {
      width: 452 * $baseFont;
      height: 565 * $baseFont;
      background-color: #fff;
      padding: 15 * $baseFont 10 * $baseFont 10 * $baseFont;
      box-sizing: border-box;
      position: relative;

      .land-normal-main_box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        height: 100%;
        width: 100%;
        .land-logo {
          position: relative;
          width: 100%;
          height: 45 * $baseFont;

          img {
            width: 140 * $baseFont;
            position: absolute;
            left: 0;
            right: 0;
          }
          .logo-txt {
            position: absolute;
            font-size: 12 * $baseFont;
            top: 22 * $baseFont;
            left: 60 * $baseFont;
            p {
              line-height: 14 * $baseFont;
            }
          }
        }
        .land-normal-main_box_title {
          display: flex;
          align-items: center;
          margin-top: 6 * 1 * $baseFont;
          .land-normal-main_box_title-top {
            margin-right: 10px;
            p {
              font-style: normal;
              font-weight: 700;
              line-height: 24 * 1.5 * $baseFont;
              font-size: 22 * 1.6 * $baseFont;
              color: $color;
            }
          }
          .land-normal-main_box_title-bottom {
            margin-top: 2 * 1.5 * $baseFont;
            img {
              height: 15 * 1.5 * $baseFont;
              width: 45 * 1.5 * $baseFont;
              display: block;
            }
          }
        }
        .land-normal-main_box_product {
          display: flex;
          position: relative;
          flex-direction: column;
          margin-bottom: 4 * $baseFont;
          width: 100%;
          .gongzhang_style {
            position: absolute;
            left: 50%;
            bottom: 0px;
            transform: translateX(-50%);
            z-index: 2;
            ::v-deep img {
              height: 150 * $baseFont;
              width: 150 * $baseFont;
            }
          }
          .sizhang_style {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translateX(-50%) rotate(-15deg);
            z-index: 2;
            ::v-deep img {
              height: 35 * $baseFont;
            }
          }
          .land-normal-main_box_product-key {
            font-style: normal;
            font-weight: 400;
            font-size: 16 * $baseFont;
            line-height: 22 * $baseFont;
            color: #231815;
          }
          .land-normal-main_box_product-value {
            font-style: normal;
            font-weight: 700;
            font-size: 16 * $baseFont;
            line-height: 22 * $baseFont;
            color: #231815;
            text-align: right;
          }
          ul {
            display: flex;
            flex-direction: column;
            row-gap: 4 * $baseFont;
            padding-right: 5 * $baseFont;
          }
          li {
            display: flex;
            width: 100%;
            justify-content: space-between;
          }
        }
        .land-normal-main_box_promise {
          display: flex;
          flex-direction: column;
          width: 100%;
          background-color: $bgcolor;
          padding: 2 * $baseFont;
          box-sizing: border-box;
          position: relative;
          margin-bottom: 6 * $baseFont;
          overflow: hidden;
          height: 40%;
          .land-normal-main_box_promise-code-snm,
          .land-normal-main_box_promise-code-snl {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            bottom: 118 * 1 * $baseFont;
            right: 4 * 1 * $baseFont;
            width: 112 * 1 * $baseFont;
            height: 20 * 1 * $baseFont;
            .land-normal-main_box_promise-code-snm-content,
            .land-normal-main_box_promise-code-snl-content {
              display: flex;
              justify-content: center;
              align-items: center;
              position: relative;
              width: 95%;
              height: 100%;
              overflow: hidden;
              border-radius: 0 8 * 1 * $baseFont 0 8 * 1 * $baseFont;
              box-sizing: border-box;
              img {
                display: block;
                width: 100%;
              }
            }
          }
          .land-normal-main_box_promise-code-title {
            position: absolute;
            bottom: 136 * 1 * $baseFont;
            right: 8 * 1 * $baseFont;
            font-style: normal;
            font-weight: 400;
            font-size: 18 * 1 * $baseFont;
            line-height: 18 * 1 * $baseFont;
            color: $color;
          }
          .land-normal-main_box_promise-code {
            position: absolute;
            bottom: 4 * 1 * $baseFont;
            right: 8 * 1 * $baseFont;
            box-sizing: border-box;
            width: 124 * 1 * $baseFont;
            height: 124 * 1 * $baseFont;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .land-normal-main_box_promise-code-img {
              position: relative;
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              ::v-deep img,
              ::v-deep canvas {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                z-index: 10;
              }
            }
          }
          .land-normal-main_box_promise-top {
            display: flex;
            flex-direction: column;
            row-gap: 4 * $baseFont;
          }
        }
        .land-normal-main_box_footer {
          font-style: normal;
          font-weight: 400;
          font-size: 16 * $baseFont;
          line-height: 20 * $baseFont;
          color: $color;
          text-align: center;
          .p_text {
            display: flex;
            align-items: center;
            color: #6e737b;
            span {
              display: block;
            }
            .span_text {
              padding: 0 5px;
              font-weight: 800;
            }
            .triangle {
              width: 0;
              height: 0;
              border-left: 6px solid transparent;
              border-right: 6px solid transparent;
              border-bottom: 8px solid #6e737b;
            }
            .triangle_left {
              transform: rotate(90deg);
            }
            .triangle_right {
              transform: rotate(270deg);
            }
          }
        }
      }
    }
    .land-normal-main_box_promise-top-item {
      display: flex;
      flex-direction: column;
      .land-normal-main_box_promise-top-item-title {
        font-style: normal;
        font-weight: 700;
        line-height: 24 * $baseFont;
        font-size: 20 * $baseFont;
        margin-bottom: 8 * $baseFont;
        color: $color;
      }
      ul {
        display: flex;
        flex-direction: column;
        row-gap: 8 * $baseFont;
      }
      li {
        display: flex;
        align-items: center;
        &:nth-child(3) {
          width: calc(100% - 122px);
        }
        .land-normal-main_box_promise-top-item-term {
          font-style: normal;
          font-weight: 400;
          font-size: 16 * $baseFont;
          line-height: 22 * $baseFont;
          color: #231815;
          display: flex;
          width: calc(100% - 14px);
          flex-wrap: wrap;
        }
        .land-normal-main_box_promise-top-item-icon {
          height: 16 * $baseFont;
          width: 16 * $baseFont;
          background: url("./static/dcpthgz-check.png") no-repeat center;
          background-size: 100% 100%;
          margin-right: 8 * $baseFont;
          box-sizing: border-box;
        }
        .land-normal-main_box_promise-top-item-icon-normal {
          height: 16 * $baseFont;
          width: 16 * $baseFont;
          background: url("./static/dcpthgz-normal.png") no-repeat center;
          background-size: 100% 100%;
          margin-right: 8 * $baseFont;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>
